import { render, staticRenderFns } from "./dept-list.vue?vue&type=template&id=5432e43f&"
import script from "./dept-list.vue?vue&type=script&lang=js&"
export * from "./dept-list.vue?vue&type=script&lang=js&"
import style0 from "./dept-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dept-list.vue"
export default component.exports